import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { hasTokenManager } from './TokenManager';
import { hasUserDetailManager } from './UserDetailManager';
import Disclaimer from './Disclaimer';
import config, { currentCountryCode } from '../../config';
import Countries from '../Common/Country/Country.APP_ENV.ajs?preParser=preProcess';
import { withTranslationProvider, HTMLTrans } from '../Common/Translations';
import { compose } from 'recompose';
import { ContinueWithFacebook, ContinueWithGoogle } from '../Account/SocialLoginButtons';
import { connectBackendConfig } from '../Common/connectBackendConfig'

class Register extends Component {
  constructor(props) {
    super(props);
    this._register = this._register.bind(this);
    this._toLogin = this._toLogin.bind(this);
    this._toForgotPassword = this._toForgotPassword.bind(this);
    this._shouldSubscribe = this._shouldSubscribe.bind(this);
    if (this.props.location && this.props.location.query
      && this.props.location.query.redirect_uri) {
      this.redirectUri = this.props.location.query.redirect_uri.split('?')[0];
    }
  }

  _register(event) {
    event.preventDefault();
    const countries = Countries.data;
    const countryName = countries.find(country => country.id === currentCountryCode).label;

    const redirectUri = this.redirectUri;

    let postData = {
      first_name: this.first_name.value,
      last_name: this.last_name.value,
      email: this.email.value,
      password: this.password.value,
      country_name: countryName,
      country_code: currentCountryCode,
      subscribe: this._shouldSubscribe(event),
      channel_source: 'register',
    };

    $.post(config.localeApi + '/register', postData,
      (response) => {
        toastr.success(
          `${this.props.t("navbar.auth_register_welcome", "Welcome")} ${response.data.user.first_name} !!`, '',
          {"positionClass": "toast-bottom-full-width"}
        );

        this.props.setToken(response.data.token);
        this.props.setDetail(response.data.user);
        if(this.props.updateToken)
          this.props.updateToken(response.data.token);

        if (redirectUri) {
            window.location = `${redirectUri}?token=${response.data.token}`;
        }
        if(!this.props.closeModal) {
          window.location = this.props.tRoute('/account/dashboard/order');
        }

      }
    ).fail((response) => {
      if ('string' === typeof response.responseJSON.errors) {
        toastr.error(
          response.responseJSON.errors, '',
          {"positionClass": "toast-bottom-full-width"}
        );
      } else {
        Object.keys(response.responseJSON.errors).map(x => {
          toastr.error(
            response.responseJSON.errors[x], '',
            {"positionClass": "toast-bottom-full-width"}
          );
        });
      }
    });
  }

  _toLogin(event) {
    event.preventDefault();
    if (this.props.updateFormState) {
      this.props.updateFormState('login');
    } else {
      this.props.router.push(this.props.tRoute('/account/login'));
    }
  }

  _toForgotPassword(event) {
    event.preventDefault();
    if (this.props.updateFormState) {
      this.props.updateFormState('forgotpassword');
    } else {
      this.props.router.push(this.props.tRoute('/account/forgotpassword'));
    }
  }

  _shouldSubscribe(event) {
    const storeCode = config.storeCode;

    if (storeCode == 'PBEU' || storeCode == 'PBUK') {
      return event.target.subscribeNewsletterCheckbox.checked
    }

    return true;
  }

  render() {
    const {
      t,
      backendConfig: {
        facebookIntegrationEnabled = false
      } = {},
      updateToken,
      setToken,
    } = this.props;
    return (
      <form className="card border-0" method="post" onSubmit={this._register}>
        <div className="modal-header">
          <p className="text-primary font-weight-bold h3"><HTMLTrans id='navbar.auth_register_title'>Register</HTMLTrans></p>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body pt-0">
          {facebookIntegrationEnabled &&
            <ContinueWithFacebook text={t('navbar.auth_facebook', 'Continue with Facebook')} closeModal={updateToken} setToken={setToken}/>
          }
          <ContinueWithGoogle text={t('navbar.auth_google', 'Continue with Google')} closeModal={updateToken} setToken={setToken}/>
          <div className="form-group">
            <div className="row pt-4">
              <div className="col"><hr/></div>
              <div className="col-auto"><p className="ProximaNova-Bold text-gray-lighten-2 text-center m-1">OR</p></div>
              <div className="col"><hr/></div>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="register-first-name"><HTMLTrans id='navbar.auth_register_firstname'>First Name</HTMLTrans></label>
            <input type="text" id="firstNameTextbox" className="form-control" ref={(input) => this.first_name = input} placeholder={t('navbar.auth_register_firstname_placeholder', 'John')} />
          </div>
          <div className="form-group">
            <label htmlFor="register-last_name"><HTMLTrans id='navbar.auth_register_lastname'>Last Name</HTMLTrans></label>
            <input type="text" id="lastNameTextBox" className="form-control" ref={(input) => this.last_name = input} placeholder={t('navbar.auth_register_lastname_placeholder', 'Doe')} />
          </div>
          <div className="form-group">
            <label htmlFor="register-email"><HTMLTrans id='navbar.auth_register_email'>Email</HTMLTrans></label>
            <input type="text" id="emailTextbox" className="form-control" ref={(input) => this.email = input} placeholder={t('navbar.auth_register_email_placeholder', 'Email')} />
          </div>
          <div className="form-group">
            <label htmlFor="register-password"><HTMLTrans id='navbar.auth_register_password'>Password</HTMLTrans></label>
            <input type="password" id="passwordTextbox" className="form-control" ref={(input) => this.password = input}
              placeholder={t('navbar.auth_register_password_placeholder', 'Password')} />
          </div>
          <div className="row justify-content-between">
            <div className="col form-check">
              <label className="custom-control custom-checkbox">
                <input type="checkbox" className="custom-control-input" />
                <span className="custom-control-indicator" />
                <span className="custom-control-description">
                  <small><HTMLTrans id='navbar.auth_register_remember_me'>Remember me</HTMLTrans></small>
                </span>
              </label>
            </div>
            <div className="col text-right">
              <a href="#" onClick={this._toForgotPassword}><u>
                <small><HTMLTrans id='navbar.auth_register_forgot_password'>Forgot password?</HTMLTrans></small>
              </u></a>
            </div>
          </div>
          <Disclaimer {...this.props} storeCode={config.storeCode} />
          <div className="text-center">
            <input id="registerButton" className="btn btn-lg btn-block btn-primary" type="submit" value={t('navbar.auth_register_button', 'Register')} />
          </div>
        </div>
        <div className="modal-footer justify-content-center pt-0">
          <p className="text-gray m-1"><HTMLTrans id='navbar.auth_register_already_a_user'>Already a user?</HTMLTrans> </p>
          <a href="#" className="ml-2 text-secondary" onClick={this._toLogin}><u><HTMLTrans id='navbar.auth_register_login_link'>Login</HTMLTrans></u></a>
        </div>
      </form>
    );
  }
}

const enhance = compose(
  hasUserDetailManager,
  hasTokenManager,
  withRouter,
  withTranslationProvider,
  connectBackendConfig,
);

export default enhance(Register);



// WEBPACK FOOTER //
// ./src/Auth/Register.js